import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
@Pipe({
  name: 'customTermsSplitter'
})
export class CustomTermsSplitterPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (typeof value !== 'string' || value.length === 0 ) {
      return [];
    }

    const result = _(value.split('\n')).
                    map((x) =>  x.trim()).
                    filter((x) => x.length > 0).
                    value();
  }
}
